// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeLegalEntityCompany --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument, GraphQlFragmentUnion} from '@sail/data';

import type {Exact} from '@stripe-internal/data-v1/schema/types';
import type {V1PermissionToken} from '@stripe-internal/data-v1/types';
import {legalEntityAddressFragment} from './legalEntityAddressFragment';
import {legalEntityJapanAddressFragment} from './legalEntityJapanAddressFragment';

import type {LegalEntityAddressFragmentData} from './legalEntityAddressFragment';
import type {LegalEntityJapanAddressFragmentData} from './legalEntityJapanAddressFragment';

const doc = gql`
  fragment StripeLegalEntityCompanyFragment on OpenapiLegalEntityCompany {
    address {
      ...LegalEntityAddressFragment
    }
    address_kana {
      ...LegalEntityJapanAddressFragment
    }
    address_kanji {
      ...LegalEntityJapanAddressFragment
    }
    name
    name_kana
    name_kanji
    phone
    tax_id
    verified
  }

  ${legalEntityAddressFragment}
  ${legalEntityJapanAddressFragment}
`;

export const stripeLegalEntityCompanyFragment: StripeLegalEntityCompanyFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeLegalEntityCompanyFragmentData = {
  readonly __typename: 'OpenapiLegalEntityCompany';
  readonly name: string | null;
  readonly name_kana: string | null;
  readonly name_kanji: string | null;
  readonly phone: string | null;
  readonly tax_id: string | null;
  readonly verified: boolean | null;
  readonly address: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiLegalEntityAddress'},
    [LegalEntityAddressFragmentData]
  > | null;
  readonly address_kana: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiLegalEntityJapanAddress'},
    [LegalEntityJapanAddressFragmentData]
  > | null;
  readonly address_kanji: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiLegalEntityJapanAddress'},
    [LegalEntityJapanAddressFragmentData]
  > | null;
};

export type StripeLegalEntityCompanyFragmentVariables = Exact<{
  [key: string]: never;
}>;

const stripeLegalEntityCompanyFragmentPermissions = {
  ...legalEntityAddressFragment.permissions,
  ...legalEntityJapanAddressFragment.permissions,
} as const;

doc.permissions = stripeLegalEntityCompanyFragmentPermissions;

export type StripeLegalEntityCompanyFragmentPermissions = V1PermissionToken<
  typeof stripeLegalEntityCompanyFragmentPermissions
>;

export type StripeLegalEntityCompanyFragmentDocument = GraphQlDocument<
  StripeLegalEntityCompanyFragmentData,
  StripeLegalEntityCompanyFragmentVariables,
  StripeLegalEntityCompanyFragmentPermissions
>;
